import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';

import { NSCommonConstants } from '@ruby/configs/common.constants';
import { NSUnitTrainDialogsConstants } from '@ruby/configs/unit-train-dialogs.constants';
import { IUTGridData, IUTLoadTrainRequest } from '@ruby/modules/unit-train/models/unit-train.interface';

@Component({
  selector: 'ng-ut-load-train-confirmation-dialog',
  templateUrl: './load-train-confirmation.dialog.html',
  styleUrls: ['./load-train-confirmation.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadTrainConfirmationDialog {
  @Input() data!: Partial<IUTGridData>;
  @Input() origin!: string;
  @Input() shipmentId!: number;
  @Input() commodity!: string;
  @Output() loadShipment = new EventEmitter<IUTLoadTrainRequest>();
  grid!: AgGridAngular;
  form = new UntypedFormGroup({
    option: new UntypedFormControl('permit'),
    traceCar: new UntypedFormControl('', Validators.pattern(NSCommonConstants.validEquipmentWithSpace))
  });
  gridConfigs = NSUnitTrainDialogsConstants.loadTrainPermitGridConfigs;

  constructor() { }

  /**
   * Set Grid
   *
   * @summary Sets the Grid reference
   * @param $grid: AgGridAngular
   * @return void
   */
  setGrid($grid: AgGridAngular): void {
    this.grid = $grid;
  }

  /**
   * Emit Load Shipment
   *
   * @summary will emit loadShipment
   * @returns void
   */
  emitLoadShipment(): void {
    const request: IUTLoadTrainRequest = {
      carInformation: { carInit: '', carNbr: '' },
      loadTrainEmptyPermits: [],
      loadTrainLoadedPermits: [],
      loadPermit: this.data,
      manualCarEntry: false,
      commodity: this.commodity,
      origin: this.origin,
      shipmentId: this.shipmentId
    };
    switch (this.form.controls.option.value) {
      case 'permit':
        request.loadTrainEmptyPermits = this.grid.api.getSelectedRows();
        break;
      case 'traceCar':
        const splitCarId: Array<string> = this.form.controls.traceCar.value.split(' ');
        request.carInformation!.carInit = splitCarId[0];
        request.carInformation!.carNbr = splitCarId[1].padStart(10, '0');
        break;
      case 'carEntry':
        request.manualCarEntry = true;
        break;
    }
    this.loadShipment.emit(request);
  }
}
